import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInsights,
  fetchInsightsByCategory,
  fetchInsightById,
  createInsight,
  updateInsight,
  deleteInsight,
} from "./insightActions";

const insightSlice = createSlice({
  name: "insights",
  initialState: {
    insights: [],           // all insights
    insight: null,          // single insight
    categoryInsights: [],   // insights filtered by category
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetBlogState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ Fetch All Insights
      .addCase(fetchInsights.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInsights.fulfilled, (state, action) => {
        state.loading = false;
        state.insights = action.payload;
      })
      .addCase(fetchInsights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ Fetch Insights by Category
      .addCase(fetchInsightsByCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInsightsByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryInsights = action.payload;
      })
      .addCase(fetchInsightsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ Fetch Single Insight by ID
      .addCase(fetchInsightById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInsightById.fulfilled, (state, action) => {
        state.loading = false;
        state.insight = action.payload;
      })
      .addCase(fetchInsightById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ Create Insight
      .addCase(createInsight.fulfilled, (state, action) => {
        state.insights.push(action.payload);
        state.success = true;
      })

      // ✅ Update Insight
      .addCase(updateInsight.fulfilled, (state, action) => {
        const index = state.insights.findIndex((b) => b._id === action.payload._id);
        if (index !== -1) state.insights[index] = action.payload;
        state.success = true;
      })

      // ✅ Delete Insight
      .addCase(deleteInsight.fulfilled, (state, action) => {
        state.insights = state.insights.filter((b) => b._id !== action.payload);
        state.success = true;
      });
  },
});

export const { resetInsightState } = insightSlice.actions;
export default insightSlice.reducer;